import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { toast } from "sonner";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function SpotifyCallback() {
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "processing", message: "Connecting to Spotify..." });

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const stateParam = params.get("state");
      const error = params.get("error");
      const returnTo = localStorage.getItem("spotify_return_to") || "/servers";

      if (error) {
        setState({ status: "error", message: `Spotify auth denied: ${error}` });
        setTimeout(() => navigate(returnTo), 2500);
        return;
      }
      if (!code) {
        setState({ status: "error", message: "No auth code received from Spotify" });
        setTimeout(() => navigate(returnTo), 2500);
        return;
      }
      try {
        const r = await api.post("/spotify/callback", { code, state: stateParam });
        toast.success(`Spotify connected · ${r.data.profile.display_name || r.data.profile.id}`);
        setState({ status: "ok", message: `Connected as ${r.data.profile.display_name || r.data.profile.id}` });
        localStorage.removeItem("spotify_return_to");
        setTimeout(() => navigate(returnTo), 800);
      } catch (e) {
        const detail = e?.response?.data?.detail || e.message;
        setState({ status: "error", message: `Failed: ${detail}` });
        setTimeout(() => navigate(returnTo), 3000);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const Icon = state.status === "ok" ? CheckCircle2 : state.status === "error" ? XCircle : Loader2;
  const color = state.status === "ok" ? "text-[#10B981]" : state.status === "error" ? "text-[#EF4444]" : "text-[#8B5CF6]";

  return (
    <div className="min-h-screen bg-[#06070A] mm-grid-bg flex items-center justify-center text-white" data-testid="spotify-callback">
      <div className="absolute inset-0 mm-noise pointer-events-none" />
      <div className="relative z-10 border border-white/10 bg-[#0D0E15] p-8 max-w-md w-full mx-4 text-center">
        <Icon className={`w-12 h-12 mx-auto mb-4 ${color} ${state.status === "processing" ? "animate-spin" : ""}`} />
        <div className="font-display font-black text-xl mb-2">SPOTIFY</div>
        <div className="font-mono text-xs text-[#94A3B8]">{state.message}</div>
      </div>
    </div>
  );
}
